module.exports = __webpack_public_path__ + "static/media/parking-A.ba871dcb.svg";